__turbopack_context__.v({
  "wrapper": "_2VJZBW_wrapper",
  "wrapperAsDialog": "_2VJZBW_wrapperAsDialog",
});
